import { Container, Row, Col, Card } from 'react-bootstrap';
import '../style/AboutPage.css';

const AboutPage = () => {
    return (
        <>
            {/* --- 1. Bagian Banner --- */}
            <div className="about-banner">
                <Container>
                    {/* <h1 className="display-3 banner-title">Tentang Syailendra Auction</h1> */}
                </Container>
            </div>

            <div className="about-content-section">
                <div className='py-5'>
                    <Container>
                        {/* --- 2. Bagian Deskripsi Utama dengan Latar Belakang --- */}
                        {/* ↓↓↓ Wrapper baru ditambahkan di sini ↓↓↓ */}
                        <div className="history-section">
                            <Row className="justify-content-center text-center">
                                <Col lg={8}>
                                    <h2 className="section-title">Sejarah & Komitmen Kami</h2>
                                    <p className="lead text-muted">
                                        Berawal dari kecintaan mendalam terhadap warisan numismatik, Syailendra Auction didirikan pada tahun 2025 untuk menjadi wadah terpercaya bagi para kolektor di Indonesia. Kami hadir untuk menjawab kebutuhan akan sebuah platform lelang yang tidak hanya transparan dan aman, tetapi juga didukung oleh keahlian kurasi yang mendalam.
                                        Setiap koin dan uang kertas memiliki cerita uniknya sendiri. Dipimpin oleh tim ahli yang berdedikasi pada nilai historis dan artistik di balik setiap objek, kami berkomitmen untuk memberikan evaluasi yang akurat serta layanan pelanggan berstandar internasional. Integritas adalah fondasi kami, memastikan setiap transaksi berjalan dengan keyakinan dan kepuasan penuh.
                                    </p>
                                    <p>
                                        Dipimpin oleh tim ahli yang bersemangat tentang sejarah dan nilai di balik setiap koin dan uang kertas, kami berkomitmen untuk memberikan evaluasi yang akurat dan layanan pelanggan yang luar biasa.
                                    </p>
                                </Col>
                            </Row>
                        </div>

                        {/* --- 3. Bagian Misi & Visi --- */}
                        <Row className="mt-5">
                            <Col md={6} className="mb-3">
                                <Card className="h-100 border-0 shadow-sm p-4">
                                    <h3 className="mission-vision-title">Misi Kami</h3>
                                    <p>Menjadi jembatan yang menghubungkan kolektor dengan artefak numismatik bernilai sejarah tinggi melalui platform lelang yang mengedepankan integritas, keahlian, dan inovasi. Kami berupaya untuk melestarikan warisan budaya sambil memberikan nilai investasi terbaik bagi klien kami.</p>
                                </Card>
                            </Col>
                            <Col md={6} className="mb-3">
                                <Card className="h-100 border-0 shadow-sm p-4">
                                    <h3 className="mission-vision-title">Visi Kami</h3>
                                    <p>Menjadi balai lelang numismatik paling terkemuka dan dihormati di Asia Tenggara, yang dikenal karena koleksinya yang luar biasa, layanannya yang tanpa cela, dan perannya dalam memperkaya komunitas kolektor global.</p>
                                </Card>
                            </Col>
                        </Row>

                    </Container>
                </div>
            </div>
        </>
    );
}

export default AboutPage;
